import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { SiteHeader, SiteFooter } from "@/components/SiteHeader";
import { ArticleCard, Cover, Eyebrow } from "@/components/ArticleCard";

const Hero = ({ a }) => (
  <Link to={`/berita/${a.slug}`} data-testid="hero-article" className="group grid lg:grid-cols-12 gap-8 fade-up">
    <div className="lg:col-span-8 aspect-[16/9] overflow-hidden bg-slate-100 img-zoom"><Cover url={a.image_url} /></div>
    <div className="lg:col-span-4 flex flex-col justify-center space-y-4">
      <Eyebrow cat={a.category} />
      <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-slate-950 group-hover:text-[#C8102E] transition-colors">{a.title}</h1>
      {a.summary && <p className="text-base leading-relaxed text-slate-600">{a.summary}</p>}
      <p className="text-xs uppercase tracking-widest text-slate-500">{a.author} · {formatDate(a.created_at)}</p>
    </div>
  </Link>
);

export default function Home() {
  const { slug } = useParams();
  const [arts, setArts] = useState(null);

  useEffect(() => {
    setArts(null);
    api.get("/articles", { params: slug ? { category: slug } : {} }).then((r) => setArts(r.data)).catch(() => setArts([]));
  }, [slug]);

  const [hero, ...rest] = arts || [];
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-14">
        {arts === null && <p className="text-slate-500">Memuat berita...</p>}
        {arts && arts.length === 0 && <p data-testid="empty-articles" className="text-slate-500 py-20 text-center">Belum ada berita di kategori ini.</p>}
        {hero && <Hero a={hero} />}
        {rest.length > 0 && (
          <section className="mt-16">
            <h2 className="text-base md:text-lg font-bold uppercase tracking-[0.2em] text-slate-900 border-t-4 border-slate-950 pt-4 mb-8">Berita Lainnya</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
              {rest.map((a, i) => <ArticleCard key={a.id} a={a} i={i} />)}
            </div>
          </section>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
